import { Route, Switch, useRouteMatch } from "react-router-dom";
import UserAccessList from "./UserAccessList";
import UserAccessCreateEditor from "./UserAccessCreateEditor";
import UserAccessEditEditor from "./UserAccessEditEditor";

const UserAccess = ({ corporation, viewMode }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/new`}>
        <UserAccessCreateEditor corporation={corporation} viewMode={viewMode} />
      </Route>
      <Route exact path={`${path}/:id`}>
        <UserAccessEditEditor corporation={corporation} />
      </Route>
      <Route exact path={path}>
        <UserAccessList corporation={corporation} viewMode={viewMode} />
      </Route>
    </Switch>
  );
};

export default UserAccess;
